angular.module('jv.Common.browser.details', [])
    .service('browserDetails', window.getBrowserDetails);